const textField = {
    width: "90%"
}

export { textField };